import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";

import { CreditoUpdate } from "../components/CreditoUpdate";
import { NotificacionCreate } from "./NotificacionCreate";

import { FormatDate } from "../components/documentacion/FormatDate";

import * as APIUSER from "../services/user";

import * as APILOG from "../services/gananciaslog";

import { GananciasModal } from "../components/GananciasModal";

export function Creditos(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isCreatingButton, setIsCreatingButton] = useState(false);

  const [isRetiradaModalOpen, setIsRetiradaModalOpen] = useState(false);
  const [retiradaMessage, setRetiradaMessage] = useState("");

  const [credito, setCredito] = useState(0);
  const [pacienteId, setPacienteId] = useState(0);
  const [pacienteNHC, setPacienteNHC] = useState(0);

  const [accountHolder, setAccountHolder] = useState("");
  const [accountNumber, setAccountNumber] = useState("");

  const { state } = useLocation();

  let dateWithHyphens;
  let d;
  let time;

  if (typeof state !== "undefined" && state !== null) {
    let { date } = state;
    dateWithHyphens = date.split("T")[0];
    d = new Date(date);
  } else {
    dateWithHyphens = new Date()
      .toISOString()
      .replace(/T.*/, "")
      .split("-")
      .join("-");
    d = new Date();
  }

  const citaFecha = dateWithHyphens;

  // Función que limpia los espacios antes de actualizar el estado
  const handleAccountNumberChange = (e) => {
    const rawValue = e.target.value; // Valor con espacios
    const cleanValue = rawValue.replace(/\s+/g, ""); // Valor sin espacios

    setAccountNumber(cleanValue); // Establecer el valor limpio con una breve demora
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Obtener los datos del usuario
        const currentUserData = await APIUSER.getCurrentUser();
        console.log(currentUserData);
        if (currentUserData) {
          setCredito(currentUserData?.meta?.credito);
          setPacienteNHC(currentUserData?.meta?.hce);
          setPacienteId(currentUserData?.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      } finally {
        setIsLoading(false); // Marcar como cargado
      }
    };

    fetchUserData();
  }, [isCreatingButton]);

  const formatCurrency = (amount) => {
    if (isNaN(amount)) return "€0.00";
    return `€${parseFloat(amount).toFixed(2)}`;
  };

  // Controlador de envío del formulario
  const submitForm = async (e) => {
    e.preventDefault();
    if (credito === 0) {
      return;
    }
    setIsCreatingButton(true);
    console.log(credito, pacienteId);
    try {
      await CreditoUpdate(0, pacienteId).then(
        (val) => {
          const fechaActual = new Date().toISOString();
          const logText = `Retirada de fondos. - ${credito}€`;
          APILOG.createGananciasLog(fechaActual, pacienteId, logText)
            .then((logVal) => {
              console.log("Log de ganancias creado:", logVal);
            })
            .catch((error) => {
              console.error("Error al crear ganancias log:", error);
            });

          // Crear la notificación pada Admin
          let adminId = 49;
          let cleanDate = FormatDate(citaFecha); // Usamos citaFecha porque no tienes metaFecha en este contexto
          let notiText = `${cleanDate} - Paciente con NHC ${pacienteNHC} solicita retirada de fondos con los siguientes datos: \nCantidad: ${formatCurrency(
            credito
          )} \nIBAN de cuenta bancaria: ${accountNumber} \nTitular de cuenta: ${accountHolder}`;

          // Crear la notificación (solo uno, sin bucle)
          NotificacionCreate(adminId, citaFecha, notiText, null, false).then(
            (val) => {
              setRetiradaMessage(
                `Le transferimos ${formatCurrency(credito)}€ a su cuenta bancaria.`
              );
              setIsRetiradaModalOpen(true);
              console.log("Notificación creada:", val);
            },
            (error) => {
              console.log("Error creando notificación:", error);
            }
          );
          console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
    setIsCreatingButton(false);
  };

  if (isLoading) {
    return <span className="loader"></span>; // Muestra algo mientras se cargan los datos del usuario
  }

  return (
    <>
      <div id="content" className="creditos-container">
        <form id="formCredito" onSubmit={submitForm}>
          <h3>Ganancias</h3>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="cantidadAcumulada">Cantidad acumulada</label>
              <div className="control">
                <input
                  className="input"
                  id="cantidadAcumulada"
                  readOnly
                  disabled
                  type="text"
                  value={formatCurrency(credito)}
                />
              </div>
            </div>
          </div>
          <div className="grid--2col">
            {/* Campo para el número de cuenta bancaria */}
            <div className="field">
              <label htmlFor="accountNumber">IBAN de cuenta bancaria</label>
              <div className="control">
                <input
                  className="input"
                  id="accountNumber"
                  type="text"
                  placeholder="ES9121000418450200051332"
                  value={accountNumber}
                  onChange={handleAccountNumberChange}
                  required
                />
              </div>
            </div>

            {/* Campo para el titular de la cuenta */}
            <div className="field">
              <label htmlFor="accountHolder">Titular de la cuenta</label>
              <div className="control">
                <input
                  className="input"
                  id="accountHolder"
                  type="text"
                  placeholder="Introduce el nombre del titular"
                  onChange={(e) => setAccountHolder(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
        </form>
      </div>

      <div id="actions">
        <button
          className="button is-link"
          id="saveButton"
          form="formCredito"
          type="submit"
          disabled={isCreatingButton || credito === 0}
        >
          {isCreatingButton ? (
            <div className="spinner"></div>
          ) : (
            "Retirar Fondos"
          )}
        </button>
      </div>

      <GananciasModal
        isOpen={isRetiradaModalOpen}
        onClose={() => setIsRetiradaModalOpen(false)}
        title="Fondos retirados"
        message={retiradaMessage}
        buttonStyle="is-danger"
      />
    </>
  );
}
